import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import Select from 'react-select';
import Clipboard from 'clipboard';

import Dialog from '../dialog';
import Events from '../../../../common/events';
import recurlyOptions from './recurlyOptions';
import globalconfig from '../../../../common/config';
import CognitoUtil from '../../../../aws/cognito/cognitoUtil';
import RavenDataStore from '../../../../common/ravenDataStore';



export class NewUserCreateModal extends Component {

    constructor() {
    
        super();

        this.state = {
            ravenData: { accounts: [] },
            channel: '',
            channelid: -1,
            email: '',
            passwd: null,
            name: '',
            isOpen: false,
        };

        this.localState = {}

        this.dataStore = new RavenDataStore(this.dataChangeCallback);
        document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingMessage: 'Loading Raven List' } }));



    }

    componentDidMount() {
        // Get all accounts
        this.dataStore.queryAccounts(this.props.stage);
        this.localState.stage = this.props.stage;

    }

    componentWillReceiveProps(nextProps) {
        this.ravenList = this.state.ravenData.accounts.map(elem => {
                var obj = elem['account'];
                if(!obj)
                    return null;

                if(obj['channelCode'] !== 'RAVEN' && obj['channelCode'] !== 'TELUS')
                    return null;

                return { value : '' + obj['email'],
                    label: '' + obj['email'] + ' (' + obj['accountExternalId'] + ')',
                    id: obj['accountId'],
                    obj: obj,
                    isDisabled: obj['type'] !== 'FLEET',
                    disabled: obj['type'] !== 'FLEET'
                };

            });
    }

    componentDidUpdate() {

        var cb = new Clipboard('#copyPasswdBtn');

        if(this.props.stage !== this.localState.stage)
        {
            this.localState.stage = this.props.stage;
            this.dataStore.queryAccounts(this.props.stage);
        }

    }

    dataChangeCallback = (ravenData) => {
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        this.setState({ravenData: ravenData});
    }


    openModal = (e) => {
        this.setState({isOpen: true});
    }

    closeModal = (e) => {
        this.setState({isOpen: false});
    }

    onSelectRavenSearch = (id) => {

        var entry = this.state.ravenData.accounts.find((elem) => {
            if(!elem.account)
                return false;
            return elem.account.email === id.value;
        });

        if(entry)
        {
            this.setState({"account": id});
        }
    }


    onRoleChange = (val) => {
        this.setState({roleid: val });
    }

    onEmailChange = (val) => {
        this.setState({email: val });
    }

    onNameChange = (val) => {
        this.setState({name: val });
    }

    onChannelChange = (val) => {
        if(val.obj['channelId'] === 0)
        {
            this.setState({channel: val.obj['channelName'], channelid: val.obj['channelId'] });
        }
        else
        {
            this.setState({
                channel: val.obj['channelName'], 
                channelid: val.obj['channelId'], 
            });
        }

    }

    reportErrorToUser = (err) => {

        console.error(err);
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        var message = err && err.message ? err.message : "An unknown error occured while trying to create new user. Please contact support to resolve this issue."; //TODO LOC BILLING
        this.setState({ message: message, messageType: 'error' });
    }


    onCreateUser = (e) => {
        e.preventDefault();
        var form = e.target;

        if(!this.state.account || !this.state.account.value)
        {
            return this.reportErrorToUser({message: "No Account Selected", messageType: 'error'}); 
        }

        if(!this.state.email)
        {
            return this.reportErrorToUser({message: "Email not set", messageType: 'error'}); 
        }

        if(!this.state.roleid)
        {
            return this.reportErrorToUser({message: "Role not set", messageType: 'error'}); 
        }

        else
        {
            this.performUserCreate(null);
        }
    }

    performUserCreate = (recurlyToken) => {
    
        document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE,
                { detail: { loadingMessage: 'Creating Fleet User For Account' } }));


        /* FIXME - add token to URL*/
        console.log("PERFORM USER CREATE", this.props.stage, 
                this.state.account.value.toLowerCase(), this.state.email.toLowerCase(), 
                this.state.name, this.state.roleid.label);


        this.props.dataStore.createFleetUser(this.props.stage, 
                this.state.account.value.toLowerCase(), this.state.email.toLowerCase(), 
                this.state.name, this.state.roleid.label, 
                (json) => {
                // On Success
              document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));

              if(!json.payload)
                {
                  document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
                  this.setState({message: "Error: " + json.errorMessage ? json.errorMessage : "Unknown" , messageType: 'error'});
                  console.error("User Create Error", json);
                  return;
                }

              this.setState({
                    created: true, 
                    passwd: json.payload.temporaryPassword,
                    message: json.status + ": Temporary Password: " + json.payload.temporaryPassword,
                    messageType: 'success'
                });
            
        }, (error) => {
                // On Fail
              document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
              this.setState({message: "Error: " + error, messageType: 'error'});
              console.error("User Create Error", error);
        });

    }

    doNothing = (e) => {
        e.preventDefault();
    }

    render() {

        // FIXME - probably not the most efficient.
        this.roles = [ { value : '0', label: 'ADMIN' },
                    { value : '1', label: 'VIEWER' },
                ];

        var errorMessage = null;

        if(this.state.messageType === 'success')
        {
            errorMessage = this.state.message ?
                <p className="success-message"><i className="material-icons">check_circle_outline</i>{this.state.message}</p> :
                null;
        }
        else
        {
            errorMessage = this.state.message ?
                <p className="error-message"><i className="material-icons">error_outline</i>{this.state.message}</p> :
                null;
        }

        return (
            <Dialog
                size="medium"
                className="test"
                label={this.props.title}
                isOpen={this.props.isOpen}
                onClose={this.props.onClose}
                onAfterOpen={this.reinitializeRecurly}
                >

                <div className="container-fluid form-card">

                    <div className="row">

                        <div className="col-12 content-group">

                            <h2>New User Details</h2>

                            <div className="row">
                                <div className="col-2">
                                    <label htmlFor="stage">Stage</label>
                                </div>
                                <div className="col-4">{this.props.stage} </div>
                                <div className="col-2">
                                    <label htmlFor="role">Role</label>
                                </div>
                                <div className="col-2">
                                    <Select id="role"
                                    placeholder="Role..."
                                    searchable={true}
                                    value={this.state.roleid}
                                    options={this.roles}
                                    name="channel"
                                    onChange={this.onRoleChange}
                                    clearable={false} />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-2">
                                    <label htmlFor="account">Existing Account</label>
                                </div>
                                <div className="col-10" >
                                    <Select id="ravenSearch"
                                        placeholder="Search..."
                                        searchable={true}
                                        options={this.ravenList}
                                        value={this.state.account}
                                        name="ravenSearch"
                                        filterOption={(option, filter) => {
                                            if(!option)
                                                return false;
                                            // Search: ravenid, raven unit id, email, raven enclosure id 
                                            else if(option.obj['accountId'] && option.obj['accountId'].toString().includes(filter))
                                                return true;
                                            else if(option.obj['email'] && option.obj['email'].toString().includes(filter))
                                                return true;
                                            return false;
                                        }}
                                        onChange={this.onSelectRavenSearch}
                                        clearable={false} />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-2">
                                    <label htmlFor="email">New Email Address</label>
                                </div>
                                <div className="col-10">
                                    <input type="text" 
                                        name="email"
                                        onChange={(e) => { this.onEmailChange(e.target.value) }} 
                                        value={this.state.email}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-2">
                                    <label htmlFor="name">Welcome Email Name</label>
                                </div>
                                <div className="col-10">
                                    <input type="text" 
                                        name="name"
                                        onChange={(e) => { this.onNameChange(e.target.value) }} 
                                        value={this.state.name}
                                    />
                                </div>
                            </div>


                            <form className="row" onSubmit={this.onCreateUser}>

                                <div className="col-12">
                                    {this.state.email && this.state.account && this.state.roleid ?
                                        <button>Create User</button> :
                                        <button disabled>Create User</button>
                                    }
                                    {this.state.created ?
                                        <div>
                                            Temporary Password: {this.state.passwd} <button className="btn" id="copyPasswdBtn" data-clipboard-text={this.state.passwd} onClick={(e) => e.preventDefault() } >Copy to clipboard</button>
                                            <Link to={"/account/" + this.props.stage + "/" + this.state.email.toLowerCase()}>Go to Account</Link> 
                                        </div> :
                                        null
                                    }
                                    {errorMessage}
                                </div>
                            </form>


                        </div>
                    </div>
                    
                    </div>
            </Dialog>
        );
    }

}

export default class NewUser extends Component {

    constructor() {
        super();

        this.state = {
            modalIsOpen: false,
        }
    }

    openModal = (e) => {
        e.preventDefault();

        this.setState({modalIsOpen: true});
    }

    closeModal = (e) => {
        this.setState({modalIsOpen: false});
    }

    render()
    {
        var title = "Create New Fleet User (" + this.props.stage + ")"; 


        return ( 
            <div className="3rdparty d-inline-block">
                <a href="#!" onClick={this.openModal}>
                    <img src="/images/baseline_person_add_white_24dp.png" alt="New Fleet User"/>
                </a>
                <NewUserCreateModal title={title} isOpen={this.state.modalIsOpen} 
                        stage={this.props.stage}
                        onClose={() => {this.setState({modalIsOpen: false})}} 
                />
            </div>
        );

    }
}

